module.exports = __webpack_public_path__ + "assets/img/back.a0aedb6d.png";